import { render, staticRenderFns } from "./brandstory.vue?vue&type=template&id=54131da6&scoped=true&"
import script from "./brandstory.vue?vue&type=script&lang=js&"
export * from "./brandstory.vue?vue&type=script&lang=js&"
import style0 from "./brandstory.vue?vue&type=style&index=0&id=54131da6&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54131da6",
  null
  
)

export default component.exports